<template>
  <div class="notifications-wrapper">
    <transition-group name="fade" tag="div">
      <div
        v-for="(msg, index) in messages"
        :key="msg.id"
        :class="['notification', msg.type]"
      >
        {{ msg.text }}
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "Notifications",
  data() {
    return {
      messages: []
    };
  },
  methods: {
    addMessage(text, type = 'info', duration = 3000) {
      const id = Date.now() + Math.random();
      this.messages.push({ id, text, type });
      setTimeout(() => {
        const index = this.messages.findIndex(m => m.id === id);
        if (index !== -1) this.messages.splice(index, 1);
      }, duration);
    },
    success(text, duration) { this.addMessage(text, 'success', duration); },
    error(text, duration) { this.addMessage(text, 'error', duration); },
    info(text, duration) { this.addMessage(text, 'info', duration); },
    loading(text, duration) { this.addMessage(text, 'loading', duration); }
  }
};
</script>

<style scoped>
.notifications-wrapper {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9999;
}

/* Transitions */
.fade-enter-active, .fade-leave-active { transition: all 0.3s ease; }
.fade-enter-from { opacity: 0; transform: translateY(-10px); }
.fade-enter-to { opacity: 1; transform: translateY(0); }
.fade-leave-from { opacity: 1; transform: translateY(0); }
.fade-leave-to { opacity: 0; transform: translateY(-10px); }

.notification {
  padding: 12px 20px;
  border-radius: 8px;
  color: #fff;
  min-width: 200px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  font-weight: 500;
  word-wrap: break-word;
}

/* Notification types */
.notification.success { background-color: #28a745; }
.notification.error { background-color: #dc3545; }
.notification.info { background-color: #0d6efd; }
.notification.loading { background-color: #ffc107; color: #212529; }
</style>
